<template>
    <div class="Carrinho">
        <Header></Header>
        <template v-if="!compraAprovada">
            <section class="sollicitacursos-comprar app-conteudo" v-if="carrinho.length > 0">

                <div class="nav-comprar">
                    <div class="container">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a :class="'nav-link ' + (etapa == 0? 'active': '')" data-toggle="tab" role="tab" aria-controls="home" aria-selected="false">Identificação</a>
                            </li>
                            <li class="nav-item">
                                <a :class="'nav-link ' + (etapa == 1? 'active': '')" id="profile-tab" data-toggle="tab" role="tab" aria-controls="profile" aria-selected="false">Pagamento</a>
                            </li>
                            <li class="nav-item">
                                <a :class="'nav-link ' + (etapa == 2? 'active': '')" id="contact-tab" data-toggle="tab" role="tab" aria-controls="contact" aria-selected="false">Concluir</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="container pt-4 pb-4">
                    <div class="" v-if="carrinho.length > 0">
                        <div class="tab-content tab-content-form-pagamento w-100" id="myTabContent">

                            <div :class="'tab-pane fade ' + (etapa == 0? 'show active': '')" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <div class="row">
                                    <div class="col-12 col-sm-7">
                                        <div class="tem-conta d-block d-sm-none">
                                            <h4>Já tem uma conta?</h4>

                                            <button class="btn btn-yellow pt-2 pb-2" @click="showModalLogin = !showModalLogin" style="width: 10em;">
                                                fazer login
                                            </button>

                                            <div class="row d-flex align-items-center p-3">
                                                <div class="col-5" style="border-bottom: 1px solid gray"></div>
                                                <div class="col-2 text-center">ou</div>
                                                <div class="col-5" style="border-bottom: 1px solid gray"></div>
                                            </div>
                                        </div>


                                        <h4>Cadastre-se</h4>
                                        <div class="cadastroUsuario">
                                            <Cadastro :resposta="respostaCadastro"></Cadastro>
                                        </div>

                                    </div>
                                    <div class="col-12 col-sm-5 col-compra-resumo" style=" ">
                                        <div class="compra-resumo p-4">
                                            <div class="d-none d-sm-block mb-2">
                                                <h4>Já tem uma conta?</h4>

                                                <button class="btn btn-yellow pt-2 pb-2" @click="showModalLogin = !showModalLogin" style="width: 10em;">
                                                    fazer login
                                                </button>

                                                <hr />
                                            </div>


                                            <h4 class="titulo-resumo">Resumo:</h4>

                                            <ul class="list-group">
                                                <li class="list-group-item p-2" v-for="(item,index) in treinamentos" :key="index">{{item.nmTreinamento}}</li>
                                                <!--<li class="list-group-item p-2">Treinamento - SollicitaCursos (A)</li>-->
                                            </ul>

                                            <hr />

                                            <h4 class="titulo-total">Total:</h4>

                                            <span class="valor-total d-block txt-p txt-size-24 txt-w-7 txt-blue-3">R$ {{totalCarrinho}}</span>

                                            <span class="valor-desconto d-block"></span>
                                            <span class="percentual-desconto d-block"></span>
                                            <div class="col-12 mt-3">
                                                <div class="w-100">
                                                    <button class="btn btn-yellow w-100 pt-2 pb-2" @click="nextEtapa">
                                                        Confirmar
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div :class="'tab-pane fade ' + (etapa == 1? 'show active': '')" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                <div class="row">
                                    <div class="col-12 col-sm-7">
                                        <h4>Informações do cartão de crédito</h4>

                                        <form class="" id="FormCrtCred" action="/Home/" method="post" novalidate="novalidate" enctype="multipart/form-data">
                                            <div class="row">
                                                <div class="col-sm-7">
                                                    <label for="nrCreditCard">Número do cartão</label>
                                                    <!--<input type="text"     aria-describedby="Número do cartão de crédito" data-val-required="Obrigatório">-->
                                                    <vue-mask class="form-control credit-card required"
                                                              id="DadoCartaoCreditoCRUD.nrCreditCard"
                                                              name="DadoCartaoCreditoCRUD.nrCreditCard"
                                                              v-model="numeroCartao"
                                                              placeholder="Digite o número do seu cartão de crédito"
                                                              mask="0000000000000000"
                                                              :raw="false"
                                                              required>
                                                    </vue-mask>
                                                    <span v-if="erros.find(x=>x.id=='numeroCartao')" class="labelValidacao field-validation-error" data-valmsg-for="DadoCartaoCreditoCRUD.nrCreditCard" data-valmsg-replace="true">
                                                        <span id="DadoCartaoCreditoCRUD_nrCreditCard-error" class="">{{erros.find(x=>x.id=='numeroCartao').msg}}</span>
                                                    </span>
                                                </div>
                                                <div class="col-sm-5">
                                                    <label>Validade</label>
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <select class="form-control required" v-model="nrMes" id="nrMes" name="DadoCartaoCreditoCRUD.nrMes">
                                                                <option value="">MM</option>
                                                                <option v-for="(mes,index) in meses" :value="mes.valor" :key="index">
                                                                    {{ mes.nome }}
                                                                </option>
                                                            </select>
                                                            <span v-if="erros.find(x=>x.id=='nrMes')" class="labelValidacao field-validation-error" data-valmsg-for="DadoCartaoCreditoCRUD.nrMes" data-valmsg-replace="true">
                                                                <span id="DadoCartaoCreditoCRUD_nrMes-error" class="">{{erros.find(x=>x.id=='nrMes').msg}}</span>
                                                            </span>
                                                        </div>

                                                        <div class="col-sm-6">
                                                            <select class="form-control required" v-model="nrAno" id="nrAno" name="DadoCartaoCreditoCRUD.nrAno">
                                                                <option value="">AA</option>
                                                                <option v-for="(ano,index) in getAnos()" :value="ano" :key="index">
                                                                    {{ ano }}
                                                                </option>
                                                            </select>
                                                            <span v-if="erros.find(x=>x.id=='nrAno')" class="labelValidacao field-validation-error" data-valmsg-for="DadoCartaoCreditoCRUD.nrAno" data-valmsg-replace="true">
                                                                <span id="DadoCartaoCreditoCRUD_nrAno-error" class="">{{erros.find(x=>x.id=='nrAno').msg}}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row mt-4">
                                                <div class="col-sm-7">
                                                    <label for="nmCreditCard">Nome no cartão</label>
                                                    <input type="text" v-model="comprador" maxlength="100" class="form-control required" id="nmCreditCard" name="DadoCartaoCreditoCRUD.nmCreditCard" aria-describedby="Nome no cartão" placeholder="Digite o nome impresso no cartão">
                                                    <span v-if="erros.find(x=>x.id=='comprador')" class="labelValidacao field-validation-error" data-valmsg-for="DadoCartaoCreditoCRUD.comprador" data-valmsg-replace="true">
                                                        <span id="DadoCartaoCreditoCRUD_comprador-error" class="">{{erros.find(x=>x.id=='comprador').msg}}</span>
                                                    </span>
                                                </div>

                                                <div class="col-sm-5">
                                                    <label>Código de segurança</label>
                                                    <div class="row">
                                                        <div class="col-sm-6">
                                                            <vue-mask class="form-control text-center cvv required"
                                                                      id="ccv"
                                                                      name="DadoCartaoCreditoCRUD.ccv"
                                                                      v-model="cvv"
                                                                      placeholder="CCV"
                                                                      mask="000"
                                                                      :raw="false"
                                                                      ref="ccv"
                                                                      @focusin="activeFlip = 'active'" @focusout="activeFlip = ''"
                                                                      required>
                                                            </vue-mask>
                                                            <span v-if="erros.find(x=>x.id=='cvv')" class="labelValidacao field-validation-error" data-valmsg-for="DadoCartaoCreditoCRUD.cvv" data-valmsg-replace="true">
                                                                <span id="DadoCartaoCreditoCRUD_cvv-error" class="">{{erros.find(x=>x.id=='cvv').msg}}</span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!--<div class="row mt-4">
                                        <div class="col-sm-12">
                                            <label>
                                                <input type="checkbox" /> Salvar dados do cartão
                                            </label>
                                        </div>
                                    </div>-->

                                            <div class="row mt-4">
                                                <div class="col-sm-12">
                                                    <label>Parcelas</label>
                                                    <select class="form-control required" v-model="nrParcelas" id="nrParcelas" name="DadoCartaoCreditoCRUD.nrParcelas">
                                                        <option value="">Selecione o número de parcelas</option>
                                                        <option v-for="(item,index) in parcelas" :value="item.value" :key="index">{{item.text}}</option>
                                                        <!--<option >À vista: R$ 00,00</option>-->
                                                    </select>
                                                    <span v-if="erros.find(x=>x.id=='nrParcelas')" class="labelValidacao field-validation-error" data-valmsg-for="DadoCartaoCreditoCRUD.nrParcelas" data-valmsg-replace="true">
                                                        <span id="DadoCartaoCreditoCRUD_nrParcelas-error" class="">{{erros.find(x=>x.id=='nrParcelas').msg}}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </form>

                                        <div class="row mt-4 mb-4">
                                            <div class="col-sm-9">
                                                <div class="card">
                                                    <div :class="'flip ' + activeFlip">
                                                        <div class="front">
                                                            <div class="investor">SollicitaCapacitação - Pagamento</div>
                                                            <div class="chip">
                                                                <div class="chip-line"></div>
                                                                <div class="chip-line"></div>
                                                                <div class="chip-line"></div>
                                                                <div class="chip-line"></div>
                                                                <div class="chip-main"></div>
                                                            </div>

                                                            <svg class="wave" viewBox="0 3.71 26.959 38.787" width="26.959" height="38.787" fill="white">
                                                                <path d="M19.709 3.719c.266.043.5.187.656.406 4.125 5.207 6.594 11.781 6.594 18.938 0 7.156-2.469 13.73-6.594 18.937-.195.336-.57.531-.957.492a.9946.9946 0 0 1-.851-.66c-.129-.367-.035-.777.246-1.051 3.855-4.867 6.156-11.023 6.156-17.718 0-6.696-2.301-12.852-6.156-17.719-.262-.317-.301-.762-.102-1.121.204-.36.602-.559 1.008-.504z"></path>
                                                                <path d="M13.74 7.563c.231.039.442.164.594.343 3.508 4.059 5.625 9.371 5.625 15.157 0 5.785-2.113 11.097-5.625 15.156-.363.422-1 .472-1.422.109-.422-.363-.472-1-.109-1.422 3.211-3.711 5.156-8.551 5.156-13.843 0-5.293-1.949-10.133-5.156-13.844-.27-.309-.324-.75-.141-1.114.188-.367.578-.582.985-.542h.093z"></path>
                                                                <path d="M7.584 11.438c.227.031.438.144.594.312 2.953 2.863 4.781 6.875 4.781 11.313 0 4.433-1.828 8.449-4.781 11.312-.398.387-1.035.383-1.422-.016-.387-.398-.383-1.035.016-1.421 2.582-2.504 4.187-5.993 4.187-9.875 0-3.883-1.605-7.372-4.187-9.875-.321-.282-.426-.739-.266-1.133.164-.395.559-.641.984-.617h.094zM1.178 15.531c.121.02.238.063.344.125 2.633 1.414 4.437 4.215 4.437 7.407 0 3.195-1.797 5.996-4.437 7.406-.492.258-1.102.07-1.36-.422-.257-.492-.07-1.102.422-1.359 2.012-1.075 3.375-3.176 3.375-5.625 0-2.446-1.371-4.551-3.375-5.625-.441-.204-.676-.692-.551-1.165.122-.468.567-.785 1.051-.742h.094z"></path>
                                                            </svg>

                                                            <div class="card-number">
                                                                <div class="section">{{ getNumberCreditCard(0) }}</div>
                                                                <div class="section">{{ getNumberCreditCard(4) }}</div>
                                                                <div class="section">{{ getNumberCreditCard(8) }}</div>
                                                                <div class="section">{{ getNumberCreditCard(12) }}</div>
                                                            </div>
                                                            <div class="end"><span class="end-text">Válido até: </span><span class="end-date">{{ getMonthValidThru() }}/{{ getYearValidThru() }}</span></div>
                                                            <div class="card-holder"><span class="nm-comprador">{{ getNameCreditCard() }}</span></div>
                                                            <div class="bandeira">
                                                                <img :src="logo" />
                                                            </div>
                                                        </div>

                                                        <div class="back">
                                                            <div class="strip-black"></div>
                                                            <div class="ccv">
                                                                <!--<label>ccv</label>-->
                                                                <div>{{ getCVVCreditCard() }}</div>
                                                            </div>
                                                            <div class="terms">
                                                                <p>Obrigado por adquirir um treinamento SollicitaCursos. Aproveite o seu treinamento.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                    <div class="col-12 col-sm-5 col-compra-resumo">
                                        <div class="compra-resumo p-4">
                                            <h4 class="titulo-resumo">Resumo:</h4>

                                            <ul class="list-group">
                                                <li class="list-group-item p-2" v-for="(item,index) in treinamentos" :key="index">{{item.nmTreinamento}}</li>
                                                <!--<li class="list-group-item p-2">Treinamento - SollicitaCursos (A)</li>-->
                                            </ul>

                                            <hr />

                                            <h4 class="titulo-total">Total:</h4>

                                            <span class="valor-total d-block txt-p txt-size-24 txt-w-7 txt-blue-3">R$ {{totalCarrinho}}</span>

                                            <span class="valor-desconto d-block"></span>
                                            <span class="percentual-desconto d-block"></span>
                                            <div class="col-12 mt-3">
                                                <div class="w-100">
                                                    <button class="btn btn-yellow w-100 pt-2 pb-2" @click="nextEtapa">
                                                        Confirmar
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>

                            <div :class="'tab-pane fade ' + (etapa == 2? 'show active': '')" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                <div class="row">
                                    <div class="col-12 col-sm-7" v-if="user">
                                        <h4>Confirme as informações</h4>
                                        <hr />
                                        <div class="row">
                                            <div class="col-12 col-lg-8">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">Nome</label>
                                                    <input class="form-control disabled" disabled placeholder="Nome" type="text" v-model="user.usuario.nmUsuario">
                                                </div>
                                            </div>
                                            <div class="col-12 col-lg-4">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">Telefone</label>
                                                    <input class="form-control disavled" disabled placeholder="Telefone" type="text" v-model="user.usuario.dsTelefone">
                                                </div>
                                            </div>

                                            <div class="col-12 col-lg-8 col-md-8">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">E-mail</label>
                                                    <input class="form-control disabled" disabled placeholder="E-mail" type="text" v-model="user.usuario.dsEmail">
                                                </div>
                                            </div>

                                            <div class="col-12 col-lg-4 col-md-4">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">Celular</label>
                                                    <input class="form-control disabled" disabled placeholder="Celular" type="text" v-model="user.usuario.dsCelular">
                                                </div>
                                            </div>

                                            <div class="col-12 col-lg-8 col-md-8">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">CEP</label>
                                                    <input class="form-control disabled" disabled placeholder="CEP" type="text" v-model="user.usuario.dsCep">
                                                </div>
                                            </div>

                                            <div class="col-12 col-lg-4 col-md-4">
                                            </div>

                                            <div class="col-12 col-lg-12 col-md-12">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">Edereço</label>
                                                    <input class="form-control disabled" disabled placeholder="Endereco" type="text" v-model="user.usuario.dsEndereco">
                                                </div>
                                            </div>

                                            <div class="col-12 col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">UF</label>
                                                    <input class="form-control disabled" disabled placeholder="UF" type="text" v-model="user.usuario.nmUf">
                                                </div>
                                            </div>

                                            <div class="col-12 col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">Cidade</label>
                                                    <input class="form-control disabled" disabled placeholder="Cidade" type="text" v-model="user.usuario.nmCidade">
                                                </div>
                                            </div>

                                            <div class="col-12 col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">Número</label>
                                                    <input class="form-control disabled" disabled placeholder="Número" type="text" v-model="user.usuario.nrNumero">
                                                </div>
                                            </div>

                                            <div class="col-12 col-lg-6 col-md-6">
                                                <div class="form-group">
                                                    <label class="label-form pl-2">Complemento</label>
                                                    <input class="form-control disabled" disabled placeholder="Complemento" type="text" v-model="user.usuario.dsComplemento">
                                                </div>
                                            </div>

                                            <!--<div class="col-12 col-lg-12 text-left">
                                        <p class="text-warning">* estas informações podem ser editadas em seu perfil. </p>
                                    </div>-->
                                        </div>

                                        <hr />

                                        <div class="row">
                                            <div class="col-12 col-sm-7">
                                                <label for="nrCreditCard">Número do cartão</label>
                                                <input type="text" v-model="numeroCartao" class="form-control credit-card disabled" disabled id="nrCreditCardConfirm" aria-describedby="Número do cartão de crédito" placeholder="Digite o número do seu cartão de crédito">
                                            </div>
                                            <div class="col-12 col-sm-5">
                                                <label>Validade</label>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <select class="form-control disabled" disabled v-model="nrMes">
                                                            <option value="">MM</option>
                                                            <option v-for="(mes,index) in meses" :value="mes.valor" :key="index">
                                                                {{ mes.nome }}
                                                            </option>
                                                        </select>
                                                    </div>

                                                    <div class="col-sm-6">
                                                        <select class="form-control disabled" disabled v-model="nrAno">
                                                            <option value="">AA</option>
                                                            <option v-for="(ano,index) in getAnos()" :key="index" :value="ano">
                                                                {{ ano }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-4">
                                            <div class="col-sm-7">
                                                <label for="nrCreditCard">Nome no cartão</label>
                                                <input type="text" v-model="comprador" class="form-control disabled" disabled id="nrCreditCard" aria-describedby="Nome no cartão" placeholder="Digite o nome impresso no cartão">
                                            </div>

                                            <div class="col-sm-5">
                                                <label>Código de segurança</label>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <input type="text" v-model="cvv" class="form-control text-center cvv disabled" disabled placeholder="CCV" @focusin="activeFlip = 'active'" @focusout="activeFlip = ''">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-4 mb-4">
                                            <div class="col-sm-12">
                                                <select class="form-control disabled" disabled v-model="nrParcelas">
                                                    <option value="">Selecione o número de parcelas</option>
                                                    <option v-for="(item,index) in parcelas" :value="item.value" :key="index">{{item.text}}</option>
                                                    <!--<option >À vista: R$ 00,00</option>-->
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-12 col-sm-5 col-compra-resumo">
                                        <div class="compra-resumo p-4">
                                            <h4 class="titulo-resumo">Resumo:</h4>

                                            <ul class="list-group">
                                                <li class="list-group-item p-2" v-for="(item,index) in treinamentos" :key="index">{{item.nmTreinamento}}</li>
                                                <!--<li class="list-group-item p-2">Treinamento - SollicitaCursos (A)</li>-->
                                            </ul>

                                            <hr />

                                            <h4 class="titulo-total">Total:</h4>

                                            <span class="valor-total d-block txt-p txt-size-24 txt-w-7 txt-blue-3">R$ {{totalCarrinho}}</span>

                                            <span class="valor-desconto d-block"></span>
                                            <span class="percentual-desconto d-block"></span>
                                            <div class="col-12 mt-3">
                                                <div class="w-100">
                                                    <button class="btn btn-yellow  w-100 pt-2 pb-2" @click="finalizarCompra">
                                                        Confirmar
                                                    </button>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>
                </div>
            </section>
            <div class="col-md-12" v-else>
                <div class="row text-center d-block" v-if="treinamentos.length == 0">
                    <div class="col-lg-12 col-md-12">
                        <h3 class="txt-p txt-size-25 txt-w-7 txt-blue-3">Oops!</h3>
                        <p class="txt-p txt-size-14 txt-w-4 txt-blue-3">Nenhum item no carrinho.</p>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="row mt-3">
                <CompraConcluida />
            </div>
        </template>
        
        <ModalLogin :showModal="showModalLogin"></ModalLogin>

        <Footer class="mt-5"></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import ModalLogin from '@/components/ModalLogin'
    import Cadastro from '@/components/Cadastro'
    import CompraConcluida from '@/components/CompraConcluida'

    import vueMask from 'vue-jquery-mask'
    import { urlApi, avisoErro, numeroParaMoeda, arredondar, avisoToast } from '@/config/global'
    import axios from 'axios'

    import logo from '@/assets/img/Logo.png';
    import $ from 'jquery'

    export default {
        name: 'Compra',
        components: { Header, Footer, ModalLogin, Cadastro, CompraConcluida, vueMask },
        data: function () {
            return {
                logo,

                treinamentos: [],

                etapa: 0,

                comprador: '',
                numeroCartao: '',
                nrMes: '',
                nrAno: '',
                activeFlip: '',
                cvv: '',
                nrParcelas: '',
                meses: [
                    { nome: 'Jan', valor: '01' },
                    { nome: 'Fev', valor: '02' },
                    { nome: 'Mar', valor: '03' },
                    { nome: 'Abr', valor: '04' },
                    { nome: 'Mai', valor: '05' },
                    { nome: 'Jun', valor: '06' },
                    { nome: 'Jul', valor: '07' },
                    { nome: 'Ago', valor: '08' },
                    { nome: 'Set', valor: '09' },
                    { nome: 'Out', valor: '10' },
                    { nome: 'Nov', valor: '11' },
                    { nome: 'Dez', valor: '12' },
                ],

                parcelas: [],
                qtdParcelas: 6,
                qtdSemJuros: 3,
                juros: 1.99,

                compraAprovada: false,
                showModalLogin: false,

                options: {
                    onFocus: function () {
                        alert('aa');
                        this.activeFlip = 'active';
                    },
                },

                erros: [],
            }
        },
        computed: {
            user() {
                return this.$store.state.user
            },
            carrinho() {
                return this.$store.state.carrinho
            },
            totalCarrinho() {
                if (this.treinamentos && this.treinamentos.length > 0) {
                    var total = 0;
                    for (let i = 0; i < this.treinamentos.length; i++) {
                        total += this.treinamentos[i].vlTreinamento;
                    }
                    return numeroParaMoeda(total);
                } else {
                    return 0;
                }

            },
        },
        methods: {
           
            getTreinamento(id) {
                let $this = this;
                axios.get(`${urlApi}/Treinamento/Get/${id}`)
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data != null) {
                                var treinamento = res.data.data.treinamento;
                                treinamento.categoria = res.data.data.categoria;
                                $this.treinamentos.push(treinamento);
                                $this.calculaParcelas();
                            }
                        } else {
                            avisoErro("Não foi possível carregar o curso");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar o curso");
                    });
            },

            load() {
                let $this = this;
                $this.treinamentos = [];
                if (this.carrinho && this.carrinho.length > 0) {
                    for (let i = 0; i < this.carrinho.length; i++) {
                        var item = this.carrinho[i];

                        $this.getTreinamento(item.idTreinamento);
                    }
                }

            },

            moeda(vlTreinamento) {
                return numeroParaMoeda(vlTreinamento);
            },

            nextEtapa() {
                if (this.etapa == 0) {
                    // conferir cadastro
                    if (!this.user) {
                        avisoErro("Não foi possível carregar dados de usuário");
                    } else {
                        this.etapa = 1;
                    }
                } else {
                    if (this.etapa == 1 && this.validaFormCartao()) {
                        // conferir dados cartao
                        this.etapa = 2;
                    } 
                }
            },

            validaFormCartao() {
                var result = true;
                this.erros = [];

                if (!this.numeroCartao || this.numeroCartao == "" || this.numeroCartao.length != 16) {
                    this.erros.push({ id: 'numeroCartao', show: true, msg: 'Número de cartão inválido' });
                }

                if (!this.nrMes || this.nrMes == "") {
                    this.erros.push({ id: 'nrMes', msg: 'Selecione um mês' });
                }

                if (!this.nrAno || this.nrAno == "") {
                    this.erros.push({ id: 'nrAno', msg: 'Selecione um ano' });
                }

                if (!this.comprador || this.comprador == "" || this.comprador.length > 100) {
                    this.erros.push({ id: 'comprador', msg: 'Nome inválido' });
                }

                if (!this.cvv || this.cvv == "" || this.cvv.length > 3) {
                    this.erros.push({ id: 'cvv', msg: 'Cvv inválido' });
                }

                if (!this.nrParcelas || this.nrParcelas == "") {
                    this.erros.push({ id: 'nrParcelas', msg: 'Selecione o número de parcelas' });
                }

                if (this.erros.length > 0) {
                    result = false;
                }
                
                return result;
            },


            finalizarCompra() {
                let $this = this;
                
                var compra = {
                    treinamentos: $this.treinamentos.map(a => a.idTreinamento),
                    dadosCompra: null,
                    dadosCartao: {
                        nrCreditCard: $this.numeroCartao,
                        nmCreditCard: $this.comprador,
                        ccv: $this.cvv,
                        nrParcelas: $this.nrParcelas,
                        nrMes: $this.nrMes,
                        nrAno: $this.nrAno,
                        validadeCartao: '',
                        cpf: '',
                        valor: '',
                    },
                };
                axios.post(`${urlApi}/UsuarioTreinamento/Compra`,
                    compra
                ).then(res => {
                    if (res.data) {
                        if (res.data.success) {
                            $this.compraAprovada = true;
                            avisoToast(res.data.data + " - " + res.data.msg);
                            $this.$store.commit('setCarrinho', null);
                            setTimeout(function () {
                                $this.$router.push({ name: 'MeusCursos' });
                            }, 5000);
                        } else {
                            avisoErro(res.data.data + " - " + res.data.msg);
                        }
                    } else {
                        avisoErro("Erro ao realizar a compra.");
                    }
                }).catch(function (erro) {
                    avisoErro(erro.response.data.msg + ' - ' + erro.response.data.errors[0]);
                    })
            },

            respostaCadastro(user) {
                this.login(user.dsEmail, user.dsSenha);
            },

            login(login, senha) {
                let $this = this;
                axios.post(`${urlApi}/Auth/signin`,
                    {
                        login: login,
                        password: senha,
                        //idModulo: idModulo,
                    }
                ).then(res => {
                        if (res.data.token.authenticated) {
                            res.data.token.usuario = res.data.usuario;
                            $this.$store.commit('setUser', res.data.token)
                            $this.nextEtapa();
                        } else {
                            avisoErro("Erro ao realizar login.");
                        }
                    })
                    .catch(function () {
                        avisoErro("Erro ao realizar login.");
                    })
            },

            // ----------------------

            getNumberCreditCard(index) {
                let section = this.numeroCartao.slice(index, index + 4);
                return (!section) ? '0000' : section;
            },

            getMonthValidThru() {
                return (this.nrMes) ? this.nrMes : '00';
            },

            getYearValidThru() {
                return (this.nrAno) ? this.nrAno : '00';
            },

            getNameCreditCard() {
                return (this.comprador) ? this.comprador : 'Insira o nome impresso no cartão';
            },

            getCVVCreditCard() {
                let count = this.cvv.length;
                let retorno = '';
                for (let i = 0; i < count; i++) {
                    retorno = retorno + '*';
                }
                return retorno;
            },

            getAnos() {
                let anos = [];
                let anoAtual = new Date().getFullYear();

                for (let i = anoAtual + 20; i >= anoAtual; i--) {
                    anos.push(i);
                }

                return anos;
            },

            calculaParcelas() {
                let $this = this;
                let total = 0;
                for (let i = 0; i < $this.treinamentos.length; i++) {
                    total += $this.treinamentos[i].vlTreinamento;
                }
                $this.parcelas = [];
                for (var cont = 1; cont <= $this.qtdParcelas; cont++) {
                    $this.parcelas.push(
                        {
                            value: cont,
                            text: cont + ' X ' + numeroParaMoeda(arredondar($this.calculaValorPacela(cont, total), 2)) + (cont <= $this.qtdSemJuros ? ' Sem Juros' : ' Com Juros de 1,99% a.m.')
                        }
                    );
                }
            },

            calculaValorPacela(nrParcela, valorTotal) {

                if (nrParcela <= this.qtdSemJuros) {
                    return valorTotal / nrParcela;
                } else {
                    var taxa = (this.juros / 100)
                    return valorTotal * taxa / (1 - (Math.pow((1 + taxa), (-1 * nrParcela))));
                }
            },

        },
        mounted: function () {
            if (this.user) {
                this.etapa = 1;
            } else {
                this.etapa = 0;
            }
            this.load();
            let $this = this;
            $("#ccv").focusin(function () { $this.activeFlip = 'active' });
            $("#ccv").focusout(function () { $this.activeFlip = '' });
        },
        watch: {
            user: function () {
                if (this.user) {
                    this.etapa = 1;
                } else {
                    this.etapa = 0;
                }
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


    .sollicitacursos-comprar {
        border-top: 1px solid #FBBC0D;
    }

    .nav-comprar {
        background: #163142;
    }

    .nav-comprar ul {
        border: none;
        
    }

    .nav-comprar ul li {
        margin-bottom: 0 !important;
    }

    .nav-comprar ul li a {
        border-radius: 0 !important;
        padding: 1.2rem 2.2rem;
        border: none !important;
        color: #fff;
        font-weight: bold;
        margin-bottom: 0;
    }

    .nav-comprar ul .active {
        background-color: #1D4056 !important;
        color: #FBBC0D !important;
    }


    .tab-content-form-pagamento h4 {
        font-family: 'M PLUS Rounded 1c', sans-serif;
        font-size: 1.2rem;
        color: #163142;
        font-weight: bold;
    }

    .tab-content-form-pagamento label {
        color: #7D8C97;
        font-size: 0.8rem;
        font-weight: bold;
    }

    .tab-content-form-pagamento input {
        border: 1px solid #7D8C97;
    }

    .compra-resumo {
        background: #F3F3F3;

        .titulo-resumo {
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
            color: #949494;
        }

        .titulo-total {
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            color: #868686;
        }

        .valor-total {
            font-style: normal;
            font-weight: bold;
            font-size: 25px;
            color: #163142;
        }

        .valor-desconto {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            text-decoration: line-through;
            color: #868686;
        }

        .percentual-desconto {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            color: #868686;
        }
    }

    .card {
        width: 100%;
        height: 250px;
        border: none;
    }

    .flip {
        width: inherit;
        height: inherit;
        -webkit-transition: 0.7s;
        transition: 0.7s;
        -webkit-transform-style: preserve-3d;
        transform-style: preserve-3d;
        -webkit-animation: flip 2.5s ease;
        animation: flip 2.5s ease;
    }

    .front,
    .back {
        position: absolute;
        width: inherit;
        height: inherit;
        border-radius: 15px;
        color: #fff;
        text-shadow: 0 1px 1px rgba(0,0,0,0.3);
        box-shadow: 0 1px 10px 1px rgba(0,0,0,0.3);
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        background-image: -webkit-gradient(linear, left top, right top, from(#163142), to(#555));
        background-image: linear-gradient(to right, #163142, #555);
        overflow: hidden;
    }

    .front {
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    .logo {
        position: absolute;
        top: 30px;
        right: 25px;
    }

    .investor {
        position: relative;
        top: 30px;
        left: 25px;
        text-transform: uppercase;
    }

    .chip {
        position: relative;
        top: 60px;
        left: 25px;
        display: -webkit-box;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        justify-content: center;
        width: 50px;
        height: 40px;
        border-radius: 5px;
        background-image: -webkit-gradient(linear, right top, left bottom, from(#ffecc7), to(#d0b978));
        background-image: linear-gradient(to bottom left, #ffecc7, #d0b978);
        overflow: hidden;
    }

    .chip .chip-line {
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: #333;
    }

    .chip .chip-line:nth-child(1) {
        top: 13px;
    }

    .chip .chip-line:nth-child(2) {
        top: 20px;
    }

    .chip .chip-line:nth-child(3) {
        top: 28px;
    }

    .chip .chip-line:nth-child(4) {
        left: 25px;
        width: 1px;
        height: 50px;
    }

    .chip .chip-main {
        width: 20px;
        height: 25px;
        border: 1px solid #333;
        border-radius: 3px;
        background-image: -webkit-gradient(linear, right top, left bottom, from(#efdbab), to(#e1cb94));
        background-image: linear-gradient(to bottom left, #efdbab, #e1cb94);
        z-index: 1;
    }

    .wave {
        position: relative;
        top: 20px;
        left: 100px;
    }

    .card-number {
        position: relative;
        display: -webkit-box;
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        align-items: center;
        margin: 40px 25px 10px;
        font-size: 23px;
        font-family: 'cc font', monospace;
    }

    .end {
        margin-left: 25px;
        text-transform: uppercase;
        font-family: 'cc font', monospace;
    }

    .end .end-text {
        font-size: 9px;
        color: rgba(255,255,255,0.8);
    }

    .card-holder {
        margin: 10px 25px;
        text-transform: uppercase;
        font-family: 'cc font', monospace;
    }

    .bandeira {
        position: absolute;
        right: 20px;
        bottom: 20px;
        display: -webkit-box;
        display: flex;
    }

    .bandeira img {
        width: 4rem;
    }

    .card {
        -webkit-perspective: 1000;
        perspective: 1000;
    }

    .card .flip.active {
        -webkit-transform: rotateY(180deg);
        transform: rotateY(180deg);
    }

    .back {
        -webkit-transform: rotateY(180deg) translateZ(0);
        transform: rotateY(180deg) translateZ(0);
        background: #9e9e9e;
    }

    .back .strip-black {
        position: absolute;
        top: 30px;
        left: 0;
        width: 100%;
        height: 50px;
        background: #000;
    }

    .back .ccv {
        position: absolute;
        top: 110px;
        left: 0;
        right: 0;
        height: 36px;
        width: 90%;
        padding: 10px;
        margin: 0 auto;
        border-radius: 5px;
        text-align: right;
        letter-spacing: 1px;
        color: #000;
        background: #fff;
    }

    .back .ccv label {
        display: block;
        margin: -30px 0 15px;
        font-size: 10px;
        text-transform: uppercase;
        color: #fff;
    }

    .back .terms {
        position: absolute;
        top: 150px;
        padding: 20px;
        font-size: 10px;
        text-align: justify;
    }

    .col-compra-resumo {
        margin-top: -24px;
    }

    @-webkit-keyframes flip {
        0%, 100% {
            -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
        }

        50% {
            -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
        }
    }

    @keyframes flip {
        0%, 100% {
            -webkit-transform: rotateY(0deg);
            transform: rotateY(0deg);
        }

        50% {
            -webkit-transform: rotateY(180deg);
            transform: rotateY(180deg);
        }
    }

    @media (max-width: 575.98px) {
        .col-compra-resumo {
            margin-top: 0;
        }

        .nav-comprar ul li a {
            padding: 1rem 0.8rem;
        }
    }
</style>

